import { formatTimeAgo, escapeHtml } from '../../utils/helpers';
import BaseView from '../../common/base-view';

export default class BookmarksView extends BaseView {
  constructor() {
    super();
    this.eventHandlers = {};
  }

  async render() {
    return `
      <div id="page-bookmarks" class="page-content active">
          <section class="create-wrapper" aria-labelledby="bookmarks-actions-title">
              <h2 id="bookmarks-actions-title" class="sr-only">Aksi Tersimpan</h2>
              <button type="button" id="clear-all-bookmarks" class="post-submit" style="background-color: #dc3545;" data-text_tip="Hapus semua bookmark" data-hover_tip="bottom" data-dev_tip="desktop">
                  <span class="material-symbols-rounded" aria-hidden="true">delete_sweep</span>
                  <span>Hapus Semua Tersimpan</span>
              </button>
          </section>
          <section class="post-wrapper" aria-labelledby="bookmarks-list-title">
              <h2 id="bookmarks-list-title" class="sr-only">Daftar Tersimpan</h2>
              <div class="post-list" id="bookmarks-container">
                  <div class="loading-post">
                      <div class="hg-animate" aria-hidden="true"></div>
                      <p>Memuat tersimpan...</p>
                  </div>
              </div>
          </section>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  hideClearAllSection() {
    const section = document.querySelector('.create-wrapper');
    if (section) section.style.display = 'none';
  }

  setupEventListeners(onClearAll, onDeleteBookmark, onBookmarkClick, onShareClick) {
    const clearAllBtn = document.querySelector('#clear-all-bookmarks');
    if (clearAllBtn) {
      this.eventHandlers.clearAllHandler = onClearAll;
      clearAllBtn.addEventListener('click', this.eventHandlers.clearAllHandler);
    }

    this.eventHandlers.globalClickHandler = (e) => {
      const deleteBookmarkBtn = e.target.closest('.delete-bookmark');
      if (deleteBookmarkBtn) {
        e.stopPropagation();
        const storyId = deleteBookmarkBtn.dataset.storyId;
        onDeleteBookmark(storyId);
        return;
      }

      const bookmarkBtn = e.target.closest('.bookmark-this');
      if (bookmarkBtn && bookmarkBtn.closest('#page-bookmarks')) {
        e.stopPropagation();
        const storyId = bookmarkBtn.dataset.storyId;
        onBookmarkClick(storyId);
        return;
      }

      const shareBtn = e.target.closest('.share-this');
      if (shareBtn) {
        e.stopPropagation();
        const storyId = shareBtn.dataset.storyId;
        onShareClick(storyId);
        return;
      }
    };

    document.addEventListener('click', this.eventHandlers.globalClickHandler);
  }

  cleanupEventListeners() {
    const clearAllBtn = document.querySelector('#clear-all-bookmarks');
    if (clearAllBtn && this.eventHandlers.clearAllHandler) {
      clearAllBtn.removeEventListener('click', this.eventHandlers.clearAllHandler);
    }

    if (this.eventHandlers.globalClickHandler) {
      document.removeEventListener('click', this.eventHandlers.globalClickHandler);
    }

    this.eventHandlers = {};
  }

  showLoading(container) {
    super.showLoading(container, 'Memuat tersimpan...');
  }

  showEmptyState(container, message) {
    super.showEmptyState(container, message);
  }

  showAuthRequired(container, onLoginClick) {
    super.showAuthRequired(
      container,
      'Silakan masuk atau daftar untuk melihat bookmark',
      'bookmarks-login-btn',
      onLoginClick
    );
  }

  renderBookmarks(bookmarks, container, onNavigateToPost) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (!container) return;

    container.innerHTML = '';
    
    if (bookmarks.length === 0) {
      this.showEmptyState(container, 'Belum ada postingan tersimpan');
      return;
    }

    let bookmarksHtml = '';
    bookmarks.forEach(bookmark => {
      const timeAgo = formatTimeAgo(bookmark.savedAt);
      const locationParagraphId = `bookmark-location-text-${bookmark.storyId}`;
      const mapLocationNameId = `bookmark-map-location-name-${bookmark.storyId}`;

      let distanceInfo = '';
      if (bookmark.distance !== null && bookmark.distance !== undefined) {
        distanceInfo = `<span class="distance-info">${bookmark.distance.toFixed(1)} km dari Anda</span>`;
      }

      bookmarksHtml += `
        <article class="postingan" data-story-id="${bookmark.storyId}">
          <div class="post-user">
            <div class="user-sender">
              <div class="poster-photo">
                <img src="${bookmark.userPhoto}" alt="Foto profil ${escapeHtml(bookmark.userName)}" width="48" height="48" loading="lazy">
              </div>
              <div class="sender-post">
                <h3>${escapeHtml(bookmark.userName)}</h3>
                ${bookmark.lat && bookmark.lon ? `
                  <button type="button" class="location-sender" aria-label="Lihat lokasi" data-text_tip="Lihat lokasi" data-hover_tip="right" data-dev_tip="desktop">
                    <span class="material-symbols-rounded" aria-hidden="true">location_on</span>
                    <p id="${locationParagraphId}">Memuat lokasi...</p>
                  </button>
                ` : ''}
              </div>
            </div>
            <div class="time-post">
              <p>Disimpan ${timeAgo}</p>
            </div>
          </div>
          <div class="isi-postingan">
            <div class="post-text">${escapeHtml(bookmark.description)}</div>
            ${bookmark.photoUrl ? `
              <div class="post-image">
                <img src="${bookmark.photoUrl}" alt="Story image" loading="lazy">
              </div>
            ` : ''}
          </div>
          ${bookmark.lat && bookmark.lon ? `
            <div class="location-view">
              <button type="button" class="box-mini-maps" aria-label="Lihat lokasi di peta" data-text_tip="Lihat lokasi di peta" data-hover_tip="top" data-dev_tip="desktop" data-story-id="${bookmark.storyId}">
                <div class="info-maps">
                  <div class="mini-map">
                    <span class="material-symbols-rounded" aria-hidden="true">share_location</span>
                  </div>
                  <div class="nama-daerah">
                    <h4 id="${mapLocationNameId}">Memuat lokasi...</h4>
                    <p>lat: ${bookmark.lat.toFixed(6)} &middot; lon: ${bookmark.lon.toFixed(6)}</p>
                  </div>
                </div>
                <div class="info-jarak">
                  <span class="view-location">${distanceInfo || 'Lihat Peta'}</span> 
                </div>
              </button>
            </div>
          ` : ''}
          <div class="action-post">
            <button class="bookmark-this bookmarked" data-story-id="${bookmark.storyId}" data-text_tip="Hapus dari bookmark" data-hover_tip="top" data-dev_tip="desktop">
              <span class="material-symbols-rounded" aria-hidden="true">bookmark</span>
              <span>Tersimpan</span>
            </button>
            <button class="share-this" data-story-id="${bookmark.storyId}" data-text_tip="Bagikan cerita" data-hover_tip="top" data-dev_tip="desktop">
              <span class="material-symbols-rounded" aria-hidden="true">share</span>
              <span>Bagikan</span>
            </button>
            <button class="delete-bookmark" data-story-id="${bookmark.storyId}" data-text_tip="Hapus dari bookmark" data-hover_tip="top" data-dev_tip="desktop">
              <span class="material-symbols-rounded" aria-hidden="true">delete</span>
              <span>Hapus</span>
            </button>
          </div>
        </article>
      `;
    });
    
    container.innerHTML = bookmarksHtml;

    if (onNavigateToPost) {
      const mapButtons = container.querySelectorAll('.box-mini-maps');
      mapButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const storyId = btn.dataset.storyId;
          if (storyId) {
            onNavigateToPost(storyId);
          }
        });
      });
    }
  }

  updateLocationName(storyId, locationName) {
    const locationPElement = document.getElementById(`bookmark-location-text-${storyId}`);
    if (locationPElement) {
      locationPElement.textContent = locationName;
    }
    const mapLocationH4Element = document.getElementById(`bookmark-map-location-name-${storyId}`);
    if (mapLocationH4Element) {
      mapLocationH4Element.textContent = locationName;
    }
  }

  updateClearAllButton(bookmarkCount) {
    const button = document.querySelector('#clear-all-bookmarks');
    if (!button) return;

    if (bookmarkCount === 0) {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.setAttribute('data-text_tip', 'Tidak ada bookmark untuk dihapus');
    } else {
      button.disabled = false;
      button.style.opacity = '1';
      button.style.cursor = 'pointer';
      button.setAttribute('data-text_tip', `Hapus ${bookmarkCount} bookmark`);
    }
  }

  removeBookmarkFromDOM(storyId) {
    const bookmarkElement = document.querySelector(`[data-story-id="${storyId}"]`);
    if (bookmarkElement) {
      bookmarkElement.remove();
    }
  }

  showBookmarkStats(stats) {
    const container = document.querySelector('#bookmarks-container');
    if (!container || stats.total === 0) return;

    const existingStats = document.querySelector('.bookmark-stats');
    if (existingStats) {
      existingStats.remove();
    }

    const statsDiv = document.createElement('div');
    statsDiv.className = 'bookmark-stats';
    statsDiv.style.cssText = 'padding: 1rem; margin-bottom: 1rem; background: var(--bg-container); border-radius: var(--radius-m); text-align: center;';
    
    statsDiv.innerHTML = `
      <div style="display: flex; justify-content: space-around; align-items: center;">
        <div>
          <span class="material-symbols-rounded" style="color: var(--primary); font-size: 1.5rem; display: block;">bookmark</span>
          <strong>${stats.total}</strong>
          <p style="margin: 0; font-size: 0.875rem; color: var(--text-secondary);">Total</p>
        </div>
        <div>
          <span class="material-symbols-rounded" style="color: var(--success); font-size: 1.5rem; display: block;">location_on</span>
          <strong>${stats.withLocation}</strong>
          <p style="margin: 0; font-size: 0.875rem; color: var(--text-secondary);">Dengan Lokasi</p>
        </div>
        <div>
          <span class="material-symbols-rounded" style="color: var(--info); font-size: 1.5rem; display: block;">image</span>
          <strong>${stats.withImages}</strong>
          <p style="margin: 0; font-size: 0.875rem; color: var(--text-secondary);">Dengan Gambar</p>
        </div>
      </div>
    `;

    container.insertBefore(statsDiv, container.firstChild);
  }

  updateBookmarkButton(storyId, isBookmarked) {
    const buttons = document.querySelectorAll(`.bookmark-this[data-story-id="${storyId}"]`);
    buttons.forEach(btn => {
      if (isBookmarked) {
        btn.classList.add('bookmarked');
        btn.querySelector('span:last-child').textContent = 'Tersimpan';
        btn.setAttribute('data-text_tip', 'Hapus dari bookmark');
      } else {
        btn.classList.remove('bookmarked');
        btn.querySelector('span:last-child').textContent = 'Simpan';
        btn.setAttribute('data-text_tip', 'Tambah ke bookmark');
      }
    });
  }

  cleanup() {
    this.cleanupEventListeners();
  }
}